export default "__VITE_ASSET__CUTIyUR7__"